import { BaseEntity } from "@app/models/rest/base-entity";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { Skill, SkillBasicProjection } from "@app/models/rest/skill";
import { SkillProficiency } from "@app/models/enums/skill-proficiency.enum";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel
} from "@lagoshny/ngx-hateoas-client";

@HateoasResource("skillRules")
export class SkillRule extends BaseEntity {
  skillProfile: SkillProfile;
  skill: Skill;
  skillProficiency: SkillProficiency;
}

@HateoasProjection(SkillRule, "anything")
export class SkillRuleSkillProjection extends BaseEntity {
  @ProjectionRel(Skill)
  skill: SkillBasicProjection;
  skillProficiency: SkillProficiency;
}
